import { render } from "./component-subject-rf.vue?vue&type=template&id=028c2a6e"
import script from "./component-subject-rf.vue?vue&type=script&setup=true&lang=js"
export * from "./component-subject-rf.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-subject-rf.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "028c2a6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('028c2a6e', __exports__)) {
    api.reload('028c2a6e', __exports__)
  }
  
  module.hot.accept("./component-subject-rf.vue?vue&type=template&id=028c2a6e", () => {
    api.rerender('028c2a6e', render)
  })

}


export default __exports__